import { getValidAccessToken } from "./auth";
import { backendTransportRequest, BackendResponse } from "./backendTransport";
export type { BackendResponse } from "./backendTransport";

export async function backendRequest<T = any>(
  path: string,
  body?: Record<string, any> | ArrayBuffer
): Promise<BackendResponse<T>> {
  const accessToken = await getValidAccessToken();
  if (!accessToken) return { data: null, error: { message: "Missing authentication token" } };
  return backendTransportRequest<T>(path, { body, accessToken });
}
